export default {
  102: {
    description: "Unsupported parameter `grant_type`."
  },
  103: {
    description: "Invalid request - missing required parameters."
  },
  104: {
    description:
      "Invalid client - `client_id` not found, parameter `redirect_uri` not valid"
  },
  106: {
    description: "Invalid access data."
  },
  108: {
    description: "Refresh token not valid."
  },
  109: {
    description: "Access denied - invalid access token"
  }
};
